import {
  GET_USERS,
  GET_USERS_SUCCESS,
  GET_USERS_FAIL,
  ADD_ROLE_TO_USER,
  ADD_ROLE_TO_USER_SUCCESS,
  ADD_ROLE_TO_USER_FAIL,
  DELETE_USER_ROLE,
  DELETE_USER_ROLE_SUCCESS,
  DELETE_USER_ROLE_FAIL,
  GET_AUTH_USERS
} from '../constants/users';

const initialState = {
  loading: false,
  data: null,
  error: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_USERS:
    case ADD_ROLE_TO_USER:
    case DELETE_USER_ROLE:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_USERS_FAIL:
    case ADD_ROLE_TO_USER_FAIL:
    case DELETE_USER_ROLE_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      };
    case GET_USERS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.data
      };
    case ADD_ROLE_TO_USER_SUCCESS:
    case DELETE_USER_ROLE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: state.data.map(user => user._id !== action.data._id ? user : action.data)
      };
    case GET_AUTH_USERS:
      return {
        ...state,
        data: state.data ? state.data.map(user => action.data.includes(user.email) ? { ...user, online: true } : { ...user, online: false }) : null
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/users.js